import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysNotifyService, VendorsService } from '@org/shared-services';
import { Observable, BehaviorSubject } from 'rxjs';
import { TruncatePipe } from '@org/utilities';
import {VendorTask } from '@org/interfaces';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { VendorAssociateComponent } from '@org/components';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';


@Component({
    selector: 'app-vendor-view',
    imports: [CommonModule, TruncatePipe, VendorAssociateComponent, ReactiveFormsModule],
    templateUrl: './vendorView.component.html',
    animations: [
        trigger('slideInOut', [
            state('in', style({
                transform: 'translateX(0)'
            })),
            transition(':enter', [
                style({ transform: 'translateX(100%)' }),
                animate('200ms ease-in')
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VendorViewComponent implements OnInit {
  isLoading = false;
  isCreatePanelOpen = false;
  vendorTasks$: Observable<VendorTask[]>;
  vendors$!: Observable<boolean>;
  selectedTask: VendorTask | null = null;
  inviteVendorForm!: FormGroup;
  // Modal visibility
  isInviteVendorModalVisible = false;
  private vendorTasksSubject = new BehaviorSubject<VendorTask[]>([]);

  vendorCategories = [
    { value: 'Glass', label: 'Glass' },
    { value: 'Striping', label: 'Striping' },
    { value: 'Sensor', label: 'Sensor' },
    { value: 'Alignment', label: 'Alignment' },
    { value: 'Misc', label: 'Misc' }
  ];

  // Invite Vendor Panel Visibility

  constructor(
    private vendorsService: VendorsService,
    private cdr: ChangeDetectorRef,
    private sysNotifyService: SysNotifyService,
    private fb: FormBuilder
  ) {
    this.vendorTasks$ = this.vendorTasksSubject.asObservable();
    this.vendors$ = this.vendorsService.vendors$;

     // Initialize the Invite Vendor Form
     this.inviteVendorForm = this.fb.group({
      vendorCategory: ['', Validators.required],
      contactName: ['', Validators.required],
      vendorName: [''],
      phoneNumber: ['', Validators.required],
      emailAddress: ['']
    });
  }

  ngOnInit() {
    this.loadVendorTasks();
    this.vendors$.subscribe((isInviteVendorModalVisible) => {
      this.isInviteVendorModalVisible = isInviteVendorModalVisible;
      this.cdr.markForCheck();
    });
  }

  loadVendorTasks() {
    this.isLoading = true;
    this.vendorsService.getVendorTasks().subscribe({
      next: (tasks: VendorTask[]) => {
        const sortedTasks = tasks.sort((a, b) => {
          return new Date(b.createdAt!).getTime() - new Date(a.createdAt!).getTime();
        });
        this.vendorTasksSubject.next(sortedTasks);
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  viewTask(task: VendorTask) {
    // Implement view logic
    this.openCreateVendorTask(task);
  }

  updateTaskStatus(task: VendorTask) {
    const newStatus = window.confirm('Mark as completed?') ? 'completed' : 'in-progress';
    
    this.vendorsService.updateTaskStatus(task._id as string, newStatus).subscribe({
      next: (updatedTask) => {
        const currentTasks = this.vendorTasksSubject.getValue();
        const updatedTasks = currentTasks.map(t => 
          t._id === updatedTask._id ? updatedTask : t
        );
        this.vendorTasksSubject.next(updatedTasks);
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error updating task status:', error);
      }
    });
  }

  openCreateVendorTask(task?: VendorTask) {
    this.selectedTask = task || null;
    this.isCreatePanelOpen = true;
    this.cdr.markForCheck();
  }

  closeCreatePanel() {
    this.isCreatePanelOpen = false;
    this.cdr.markForCheck();
  }

  showSuccess(msg: string) {
    this.sysNotifyService.showSuccess(msg, 3000, 'right', 'top');
  }

  showError(msg: string) {
    this.sysNotifyService.showError(msg, 3000, 'right', 'top');
  }

  showWarning(msg: string) {
    this.sysNotifyService.showWarning(msg, 3000, 'right', 'top');
  }

  openInviteVendor() {
    this.isInviteVendorModalVisible = true;

  }

  // Close Modal
  closeInviteVendorModal() {
    this.isInviteVendorModalVisible = false;
    this.inviteVendorForm.reset(); // Reset the form when closing
    this.vendorsService.closeInviteVendorPanel();
  }

   // Submit Invite Vendor Form
   submitInviteVendor() {
    if (this.inviteVendorForm.valid) {
      this.vendorsService.createTempVendor(this.inviteVendorForm.value)
        .subscribe({
        next: (data) => {
          this.showSuccess('Vendor added successfully');
          this.closeInviteVendorModal();
          },
          error: (err) => {
            this.showError('Error adding vendor');
          }
      })
      
    }
   }
}